var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5242 7.37443C23.69 7.7536 22.7908 8.00276 21.8592 8.12193C22.8125 7.54776 23.5492 6.63776 23.8958 5.5436C22.9967 6.08526 22 6.46443 20.9492 6.6811C20.0933 5.74943 18.8908 5.20776 17.5258 5.20776C14.98 5.20776 12.9 7.28776 12.9 9.85526C12.9 10.2236 12.9433 10.5811 13.0192 10.9169C9.16251 10.7219 5.72834 8.86943 3.44251 6.0636C3.04167 6.7461 2.81417 7.54776 2.81417 8.39276C2.81417 10.0069 3.62667 11.4369 4.88334 12.2494C4.11417 12.2494 3.39917 12.0328 2.77084 11.7078V11.7403C2.77084 13.9936 4.37417 15.8786 6.49751 16.3011C5.81579 16.4877 5.10011 16.5136 4.40667 16.3769C4.70091 17.3004 5.27717 18.1085 6.05444 18.6876C6.83171 19.2667 7.77091 19.5876 8.74001 19.6053C7.09727 20.9057 5.061 21.6087 2.96584 21.5986C2.59751 21.5986 2.22917 21.5769 1.86084 21.5336C3.91917 22.8553 6.36751 23.6244 8.98917 23.6244C17.5258 23.6244 22.2167 16.5394 22.2167 10.3969C22.2167 10.1911 22.2167 9.9961 22.2058 9.79026C23.1158 9.14026 23.8958 8.31693 24.5242 7.37443Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f7d5a81018fb7174e0c2080d126fa2d0.svg";
export { ForwardRef as ReactComponent };